import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7e2ae15e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "footerImg"
};
var _hoisted_2 = {
  class: "divFooter"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = ["src"];

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footerSpan"
  }, "© 2022-2023 Lindo Innovation INC", -1);
});

export default {
  setup: function setup(__props) {
    var _require = require("@vue/reactivity"),
        ref = _require.ref;

    var imgList = ref({
      url1: require("@/assets/ins@2x.png"),
      url2: require("@/assets/fb@2x.png"),
      url3: require("@/assets/yt.png"),
      url4: require("@/assets/tw.png")
    });

    var toYoutube = function toYoutube() {
      window.open("http://www.youtube.com/channel/UC0Za9Zk9_ORyQQUqNx4cDFA", "_blank");
    };

    var toInstagram = function toInstagram() {
      window.open("http://www.instagram.com/lindolife_official/", "_blank");
    };

    var toTwitter = function toTwitter() {
      window.open("https://twitter.com/lindo_life", "_blank");
    };

    var toFachbook = function toFachbook() {
      window.open("http://www.facebook.com/Lindo-Life-105532715416270", "_blank");
    };

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: imgList.value.url1,
        onClick: toInstagram
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: imgList.value.url2,
        onClick: toFachbook
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: imgList.value.url3,
        onClick: toYoutube
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: imgList.value.url4,
        onClick: toTwitter
      }, null, 8, _hoisted_6)]), _hoisted_7]);
    };
  }
};